const Title = ({ text }: { text: string }) => {
  return <div className='font-[LilitaOne] text-[24px] text-primary tracking-[1px]'>{text}</div>;
};

export default Title;
